module.exports = __webpack_public_path__ + "static/media/express.60a21276.png";